const Loading = () => {
  return (
    <div className="m-auto zuno-bg-dark pt-5">
      <span className="loaderr"></span>
    </div>
  );
};

export default Loading;
